<section class="bg-wrapper">
    <div class="login-wrap zi-2">
        <h1 data-title="Forgot Password">Forgot Password</h1>
        <img src="assets/images/title-border.svg" class="theme-border">
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
            <div class="login-form">
                <p class="mb-3" style="color: #ccc; text-align: center;">Enter your email address and we'll send you a
                    link to reset your password.</p>

                <div class="login-form-row">
                    <img src="assets/images/edit-login.svg">
                    <input type="email" placeholder="Email Address" formControlName="email" autocomplete="off">
                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                        <div *ngIf="f.email.errors.required">Email is required!</div>
                        <div *ngIf="f.email.errors.email">Email should be valid!</div>
                    </div>
                </div>
            </div>
            <div class="login-form-submit">
                <a role="button" class="btn-unfilled" routerLink="/login">Back to Login</a>
                <button type="submit" class="btn-filled" [disabled]="isLoading">
                    {{ isLoading ? 'Sending...' : 'Send Reset Link' }}
                </button>
            </div>
        </form>
    </div>
</section>